<script>

    import { onMount, onDestroy } from 'svelte'
    import { fade } from 'svelte/transition'
    import { modalStore } from '../stores'

    export let title = ''
    export let show = false

    function onClose() {
        modalStore.close()
    }

    function handleKeydown(event) {
        if (show && event.key === 'Escape') onClose()
    }

    onMount(() => window.addEventListener('keydown', handleKeydown))
    onDestroy(() => window.removeEventListener('keydown', handleKeydown))

</script>

{#if show}
    <div class="modal" class:is-active={show} in:fade="{{duration: 200}}" out:fade="{{duration: 100}}">
        <div on:click={onClose} class="modal-background"></div>
        <div class="modal-card">
            <div class="modal-card-head">
                <div class="modal-card-title">{ title }</div>
                <button on:click={onClose} class="delete" aria-label="close"></button>
            </div>
            <div class="modal-card-body">
                <slot></slot>
            </div>
            <div class="modal-card-foot"></div>
        </div>
    </div>
{/if}
